module.exports = __webpack_public_path__ + "img/ic_saleorder_set_default.9214af8d.svg";